define.alias("shared/utils/insert-text-at-cursor", "media/utils/insert-text-at-cursor");